module.exports = __webpack_public_path__ + "img/7-twoImg.4a84b8d3.png";